import React, { useState } from "react";
import ScorecardFiltersViewModel from "../../Viewmodels/ScorecardFiltersViewModel";
import ActiveStatusFiltersDialog from "./ActiveStatusFiltersDialog";
import FilterChipDisplay from "../../../Filtering/FilterChipDisplay";

interface IActiveStatusFiltersProps {
    activeStatus: string;
    changeFilter: (filterName: keyof ScorecardFiltersViewModel, newValue: any) => void;
}

export default function ActiveStatusFilters({ activeStatus, changeFilter }: IActiveStatusFiltersProps) {
    const [dialogOpen, setDialogOpen] = useState(false);

    const text = `Active Status: ${activeStatus}`

    return (
        <>
            <FilterChipDisplay
                text={text}
                selectable
                onClick={() => setDialogOpen(true)} />
            <ActiveStatusFiltersDialog
                open={dialogOpen}
                setOpen={setDialogOpen}
                currentActiveStatus={activeStatus}
                changeFilter={changeFilter} />
        </>
    )
}